import classnames from 'classnames';
import * as PropTypes from 'prop-types';
import React from 'react';

import { Label } from '../../fields/label';

import styles from './Radio.module.scss';

const Radio = ({
  className,
  id,
  label,
  checked,
  disabled,
  error,
  iconClassName,
  ...rest
}) => {
  return (
    <div className={classnames(styles.root, 'position-relative', className)}>
      <Label
        className={classnames(styles.label, { [styles.disabled]: disabled })}
        htmlFor={id}
      >
        <input
          {...rest}
          id={id}
          className={classnames(styles.input, 'position-absolute invisible')}
          type="radio"
          checked={checked}
          disabled={disabled}
        />
        <div
          className={classnames(
            styles.icon,
            iconClassName,
            'd-flex position-absolute justify-content-center align-items-center rounded-circle',
            {
              [styles.error]: error,
              [styles.disabled]: disabled,
            },
          )}
        />
        <div>{label}</div>
      </Label>
    </div>
  );
};

Radio.propTypes = {
  id: PropTypes.string,
  label: PropTypes.node,
  value: PropTypes.any,
  htmlFor: PropTypes.string,
  error: PropTypes.string,
  disabled: PropTypes.bool,
};

export default Radio;
